import React, { useState } from "react";
import "../auth-layout/AuthLayout.override.css";
import styles from "./ForgotPassword.module.css";
import { Button, Form } from "antd";
import { AppInput } from "../../../common/components/input/AppInput";
import { AppButton } from "../../../common/components/button/AppButton";
import { Link, useNavigate } from "react-router-dom";
import { forgotPasswordFormControls } from "../../forms/forgotPassword";
import { resetPasswordFormControls } from "../../forms/resetPassword";
import { AuthLayout } from "../auth-layout/AuthLayout";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { authConfirmForgotPass, authForgotPass } from "../../slices/auth.slice";
import { ERoutes } from "../../../../type/eroutes";

const codeFormControl = {
  rules: [{ required: true, message: "Please enter the reset code" }],
  name: "code",
  placeholder: "Reset Code",
};

export const ForgotPassword = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isLoading } = useAppSelector((state) => state.auth);

  const [step, setStep] = useState<1 | 2>(1);
  const [sentToEmail, setSentToEmail] = useState("");

  const onStep1Submit = (values: any) => {
    authForgotPass(values, (email: string) => {
      setSentToEmail(email);
      setStep(2);
    })(dispatch);
  };

  const onStep2Submit = (values: any) => {
    authConfirmForgotPass(
      sentToEmail,
      values.code,
      values.password,
      () => navigate(ERoutes.signIn),
    )(dispatch);
  };

  const sidePanel = (
    <Link to={ERoutes.signUp} className="createAccountLink">
      <Button className="createAccountBtn">New to Lari</Button>
    </Link>
  );

  return (
    <AuthLayout
      className="equalSideLayout"
      pageTitle={step === 1 ? "Forgot Password" : "Reset Password"}
      displayLeft={true}
      displayLeftMobile={true}
      displayRight={true}
      sideTitle="Create Account"
      sideContent="You're one step away from seeing the magic"
      sideButton={sidePanel}
      sideContainerClassName="sideForgotPass"
    >
      {step === 1 ? (
        <>
          <Link to={ERoutes.signIn} className={styles.backLink}>
            BACK
          </Link>
          <Form
            data-testid="forgot-password-form"
            name="forgotPassword"
            onFinish={onStep1Submit}
            autoComplete="off"
            className="authForm"
          >
            <AppInput config={forgotPasswordFormControls.email} />
            <AppButton
              className="submitBtn"
              text="Send Reset Code"
              htmlType="submit"
              disabled={isLoading}
            />
          </Form>
        </>
      ) : (
        <>
          <p className={styles.backLink}>
            Code sent to <strong>{sentToEmail}</strong>
          </p>
          <Form
            data-testid="reset-code-form"
            name="resetCode"
            onFinish={onStep2Submit}
            autoComplete="off"
            className="authForm"
          >
            <AppInput config={codeFormControl} />
            <AppInput config={resetPasswordFormControls.password} type="password" />
            <AppInput
              config={resetPasswordFormControls.confirmPassword}
              type="password"
            />
            <AppButton
              className="submitBtn"
              text="Reset Password"
              htmlType="submit"
              disabled={isLoading}
            />
          </Form>
        </>
      )}
    </AuthLayout>
  );
};
